import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { MasterInformationService } from '../../../Services/master-information.service';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { ReportsService } from '../../../Services/reports.service';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-menu-configuration',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InputTextModule, ToastrModule, NgbTooltipModule, FormsModule],
  templateUrl: './menu-configuration.component.html',
  styleUrls: ['./menu-configuration.component.css']
})
export class MenuConfigurationComponent implements OnInit {
  form: FormGroup;
  subMenuForm: FormGroup;
  userTypeList: any;
  sideMenuList: any;
  isEditMode: boolean = false;
  hasSubmenu: boolean = false;
  menu1Expanded = false;
  menu2Expanded = false;
  selectedMainMenuId: any;
  mainMenuId: any;
  subMenuList: any;
  subMenuId: any;
  mainId: any;
  selectedMenu: any;
  selectedSubMenu: any;
  deleteMainMenuId: any;
  isSubMenu: boolean = false;
  deleteSubMenuId: any;
  isMainMenu: boolean = false;

  constructor(private fb: FormBuilder,
    private masterService: MasterInformationService,
    private toastr: ToastrService,
    private reportService: ReportsService,
    private modalService: NgbModal) {

    this.form = this.fb.group({
      menuName: [''],
      menuUrl: [''],
      iconName: [''],
    });

    this.subMenuForm = this.fb.group({
      submenuName: [''],
      submenuUrl: [''],
      mainMenu: ['']
    })
  }

  // ------------------------------ OnInit ------------------------------ //

  ngOnInit() {
    this.getMainmenuList();
    this.getSubMenuList();
  }

  // ------------------------------ MenuArray ------------------------------ //

  get menuArray(): FormArray {
    return this.form.get('menuArray') as FormArray;
  }

  getSubmenuArray(menuIndex: number): FormArray {
    return (this.menuArray.at(menuIndex) as FormGroup).get('submenuArray') as FormArray;
  }

  removeMenuField(index: number) {
    const menuArray = this.form.get('menuArray') as FormArray;
    const menuId = menuArray.at(index).get('mainMenuid')?.value;
    console.log(menuId)

    if (menuId) {
      this.masterService.deleteMainMenu(apiEndPoints.deleteMainMenu, menuId).subscribe({
        next: (response) => {
          if (response.isSuccess) {
            this.toastr.success('Deleted Successfully', 'Success', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true
            });
            this.getMainmenuList();
          }
        }
      })
    } else {
      this.menuArray.removeAt(index);
    }
  }

  // ------------------------------ Open  ------------------------------ //

  openCreateMenuModal(modal: any) {
    this.isEditMode = false;
    this.form.reset();
    this.modalService.open(modal, { centered: true, backdrop: 'static', size: 'md' });
  }

  openSubmenuModal(modal: any) {
    this.isEditMode = false;
    this.subMenuForm.get('mainMenu')?.enable();
    this.subMenuForm.reset();
    this.modalService.open(modal, { centered: true, backdrop: 'static', size: 'md' });
  }

  openDeleteModal(menu: any, modalRef: any) {
    this.isMainMenu = true;
    this.selectedMenu = menu;
    this.deleteMainMenuId = menu.id;
    this.modalService.open(modalRef, { centered: true, backdrop: 'static' });
  }

  openSubMenuDeleteModal(subMenu: any, modalRef: any) {
    console.log(subMenu)
    this.isMainMenu = false;
    this.selectedSubMenu = subMenu
    this.deleteSubMenuId = subMenu.id;
    this.modalService.open(modalRef, { centered: true, backdrop: 'static' });
  }

  // ------------------------------ SubMenuArray ------------------------------ //

  addSubmenuField() {
    this.hasSubmenu = true;
  }

  removeSubmenuField() {
    this.form.patchValue({
      submenuName: '',
      submenuUrl: ''
    });
    this.hasSubmenu = false;
  }

  // ------------------------------ FormSubmit API ------------------------------ //

  submitForm(type: any) {
    if (type === 'new') {
      if (this.form.invalid) {
        this.form.markAllAsTouched();
        this.toastr.info('Fill in all the fields', 'Info', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
        return;
      }

      const reqBody = {
        menuList: [
          {
            menuName: this.form.value.menuName,
            icon: this.form.value.iconName,
            menuUrl: this.form.value.menuUrl,
          }
        ]
      };
      console.log(reqBody)
      this.masterService.addSidemenu(apiEndPoints.addSideMenu, reqBody).subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            this.toastr.success(response.statusText, 'Success', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true
            });
            this.modalService.dismissAll();
            this.form.reset();
            this.getMainmenuList();
            this.hasSubmenu = false;
          }
        },
        error: () => {
          this.toastr.error('Error adding sidemenu. Please try again later.', 'Error', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true
          });
        }
      });
    } else {
      if (this.form.invalid) {
        this.form.markAllAsTouched();
        this.toastr.info('Fill in all the fields', 'Info', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
        return;
      }

      const reqBody = {
        menuid: this.mainMenuId,
        menuName: this.form.value.menuName,
        menuUrl: this.form.value.menuUrl,
        icon: this.form.value.iconName,
      };

      console.log(reqBody)

      this.masterService.updateMainMenu(apiEndPoints.updateMainMenu, reqBody).subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            this.toastr.success(response.statusText, 'Success', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true
            });
            this.isEditMode = false;
            this.modalService.dismissAll();
            this.getMainmenuList();
            this.form.reset();
          }
        }
      });
    }
  }

  // ------------------------------ OnMenu Change ------------------------------ //

  onMenuChange(event: any) {
    this.selectedMainMenuId = event.target.value
  }

  // ------------------------------ Submenu FormSubmit API ------------------------------ //

  submitSubmenuForm(type: any) {
    console.log('hiiii')
    if (type == 'Submit') {
      if (this.subMenuForm.valid) {
        const reqBody = {
          subMenu: [
            {
              mainMenuId: this.selectedMainMenuId,
              subMenuName: this.subMenuForm.value.submenuName,
              subMenuUrl: this.subMenuForm.value.submenuUrl
            }
          ]
        }

        console.log(reqBody)

        this.masterService.addSidemenu(apiEndPoints.addSubMenu, reqBody).subscribe({
          next: (response: any) => {
            if (response.isSuccess) {
              console.log('vanakkam')
              this.toastr.success(response.statusText, 'Success', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true
              });
              this.modalService.dismissAll();
              this.subMenuForm.reset();
              this.getSubMenuList();
            }
          },
          error: () => {
            this.toastr.error('Error adding Submenu. Please try again later.', 'Error', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true
            });
          }
        });

      } else {
        this.subMenuForm.markAllAsTouched();
        this.toastr.info('Fill in all the fields', 'Info', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    } else {
      if (this.subMenuForm.valid) {
        const reqBody = {
          mainMenuId: this.mainId,
          subMenuId: this.subMenuId,
          subMenuName: this.subMenuForm.value.submenuName,
          subMenuUrl: this.subMenuForm.value.submenuUrl
        }

        this.masterService.updateMainMenu(apiEndPoints.updateSubMenu, reqBody).subscribe({
          next: (response: any) => {
            if (response.isSuccess) {
              this.toastr.success(response.statusText, 'Success', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true
              });
              this.modalService.dismissAll();
              this.getSubMenuList();
            }
          }
        })
      }

    }

  }

  // ------------------------------ Get Sidemenu List API ------------------------------ //

  getMainmenuList() {
    this.masterService.getMainmenu(apiEndPoints.sideMenuList).subscribe({
      next: (response: any) => {
        if (response.isSuccess) {
          this.sideMenuList = response.body.details;
          this.bindSubmenusToMainMenu();
        }
      },
      error: () => {
        this.toastr.error('Error getting MainMenu. Please try again later.', 'Error', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    });
  }

  // ------------------------------ Get Submenu List API ------------------------------ //

  getSubMenuList() {
    this.masterService.getSubmenu(apiEndPoints.subMenuList).subscribe({
      next: (response: any) => {
        if (response.isSuccess) {
          this.subMenuList = response.body.details;
          this.bindSubmenusToMainMenu();
        }
      },
      error: () => {
        this.toastr.error('Error getting SubMenu. Please try again later.', 'Error', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    });
  }

  bindSubmenusToMainMenu() {
    if (this.sideMenuList?.length && this.subMenuList?.length) {
      this.sideMenuList.forEach((menu: any) => {
        menu.submenus = this.subMenuList.filter((sub: any) => sub.mainMenuId === menu.id);
      });
    }
  }

  // ------------------------------ Edit Menu API ------------------------------ //

  editItem(menuData: any, modal: any) {
    console.log(menuData)
    this.isEditMode = true;
    this.modalService.open(modal, { centered: true, backdrop: 'static', size: 'md' });

    this.form.patchValue({
      menuName: menuData.menuName,
      menuUrl: menuData.menuUrl,
      iconName: menuData.icon,

    })
  }

  // ------------------------------ Table expand ------------------------------ //

  toggleSubmenu(menu: any) {
    menu.expanded = !menu.expanded;
  }

  // ------------------------------ Edit MainMenu API ------------------------------ //

  editMainMenu(menuData: any, modal: any) {
    this.isEditMode = true;
    this.mainMenuId = menuData.id;
    console.log(this.mainMenuId)
    this.modalService.open(modal, { centered: true, backdrop: 'static', size: 'md' });

    this.form.patchValue({
      menuName: menuData.menuName,
      menuUrl: menuData.menuURL,
      iconName: menuData.menuIcon,
    })
  }

  editSubMenu(menuData: any, subMenuData: any, modal: any) {
    console.log(subMenuData)
    this.isEditMode = true;
    this.subMenuId = subMenuData.id;
    this.mainId = subMenuData.mainMenuId;
    this.modalService.open(modal, { centered: true, backdrop: 'static', size: 'md' });

    this.subMenuForm.patchValue({
      mainMenu: subMenuData.mainMenuId,
      submenuName: subMenuData.subMenuName,
      submenuUrl: subMenuData.subMenuUrl
    });

    if (this.isEditMode) {
      this.subMenuForm.get('mainMenu')?.disable();
    } else {
      this.subMenuForm.get('mainMenu')?.enable();
    }
  }

  // ------------------------------ Delete MainMenu API ------------------------------ //

  deleteMainMenu() {
      this.masterService.deleteMainMenu(apiEndPoints.deleteMainMenu, this.deleteMainMenuId).subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            this.toastr.success(response.statusText, 'Success', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true
            });
            this.modalService.dismissAll();
            this.getMainmenuList();
          }
        },
        error: () => {
          this.toastr.error('Error Deleting MainMenu. Please try again later.', 'Error', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true
          });
        }
      });
  }

  deleteSubMenu() {
    this.masterService.deleteSubMenu(apiEndPoints.deleteSubMenu, this.deleteSubMenuId).subscribe({
      next: (response: any) => {
        if (response.isSuccess) {
          this.toastr.success(response.statusText, 'Success', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true
          });
          this.modalService.dismissAll();
          this.getSubMenuList();
        }
      },
      error: () => {
        this.toastr.error('Error Deleting SubMenu. Please try again later.', 'Error', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    });
  }


}
